import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import {API_BASE_URL} from "@/config";


Vue.use(Vuex);
export default new Vuex.Store({
    state: {
        cartProducts:[],
        userAccessKey:null,
        cartProductsData:[],
        countProductsCart:0,
        orderInfo:null,
        },
        

    mutations:{
        updateOrderInfo(state,orderInfo){
            state.orderInfo=orderInfo;
        },



        resetCart(state){
            state.cartProducts=[],
            state.cartProductsData=[]
        },
        addProductToCart(state,{productId,amount}) {
            const item = state.cartProducts.find(item => item.productId === productId);

            if (item) {
                item.amount += amount;
            } else {
                state.cartProducts.push({
                    productId,
                    amount,

                });
            }
           },
        updateCartProductsAmount(state,{productId,amount}) {
            const item = state.cartProducts.find(item => item.productId === productId);
            if (item) {
                item.amount = amount;
            }
        },
        deleteCartProduct(state,productId){
            state.cartProducts=state.cartProducts.filter(item=>item.productId!==productId)
        },
        updateUserAccessKey(state,accessKey){
            state.userAccessKey=accessKey;
        },
        updateCartProductsData(state,items){
            state.cartProductsData=items;
        },
        syncCartProducts(state){
            state.cartProducts=state.cartProductsData.map(item=>{
                return{
                    productId:item.product.id,
                    amount:item.quantity}

            });
        }
    },


    getters:{
        cartDetailsProducts(state){
            //console.log(state.cartProductsData)
            return state.cartProducts.map(item=>{
                const product=state.cartProductsData.find(p=>
                    {//console.log(p);
                    return p.product.id===item.productId}).product;
              
               return{
                
                    ...item,
                   product:{
                    ...product,
                    image:product.image.file.url}
                }
               
            })


        },

        cartTotalPrice(state,getters){
            return getters.cartDetailsProducts.reduce((acc,item)=>(item.product.price * item.amount)  +
            acc,0)}
            },
    
            actions:{
         
        //countedProductsCart(context,productId,amount){
            //console.log(context.state.userAccessKey)
            //return  axios.put(API_BASE_URL+'/api/baskets/products',{
            //    productId,
            //    quantity:amount,
            //},
            //{
            //    params:{userAccessKey:context.state.userAccessKey,},

           // })
           // .then((response)=>{ty
          //  console.log(response)})
        //},
        loadOrderInfo(context,orderId){
            return axios
            .get(API_BASE_URL+'/api/orders'+orderId,{
              params:{userAccessKey:context.state.userAccessKey}

        })
        .then(response=>{
            context.commit('updateOrderInfo',response.data)
        })






        },        
        loadCart(context){
            return axios
                .get(API_BASE_URL+'/api/baskets',{
                  params:{userAccessKey:context.state.userAccessKey}

            })
                .then(response=>{
                    if(!context.state.userAccessKey){
                    localStorage.setItem('userAccessKey',response.data.user.accessKey)
                    context.commit('updateUserAccessKey',response.data.user.accessKey)
                   
                    }


                    context.commit('updateCartProductsData',response.data.items);
                    context.commit('syncCartProducts',response.data.items)
                    this.countProductsCart=response.data.items.quantity
                    return response
                })


},
addProductToCart(context,{productId,amount}){
    //alert("123")
    return(new Promise(resolve=>setTimeout(resolve,2000)))
    .then(()=>{
  return axios.post(API_BASE_URL+'/api/baskets/products',{
      productId,
      quantity:amount,
  },{
      params:{
          userAccessKey:context.state.userAccessKey,
      },
  })  
  .then(response=>{
      context.commit('updateCartProductsData',response.data.items);
      context.commit('syncCartProducts',response);
      
  })    
  //this.countedProductsCart(context,productId,amount)
  })
},
updateCartProductAmount(context,{productId,amount}){
    context.commit('updateCartProductsAmount',{productId,amount})
    if (amount<1){
        return;
    }
    return axios.put(API_BASE_URL+'/api/baskets/products',{
        productId,
        quantity:amount,
    },{
        params:{
            userAccessKey:context.state.userAccessKey,
        },
    })  
    .then(response=>{
        context.commit('updateCartProductsData',response.data.items);
        
    }) 
        .catch(()=>{
            context.commit('syncCartProducts');
        })

},
deleteProductFromCart(context,productId){
    context.commit('deleteCartProduct',productId)
    
    return axios.delete(API_BASE_URL+'/api/baskets/products',{
        params:{
            userAccessKey:context.state.userAccessKey,
        },
        data:{productId}
    })  
    .then(response=>{
        context.commit('updateCartProductsData',response.data.items);
        
    }) 
        .catch(()=>{
            context.commit('syncCartProducts');
        })

},



/////
}
});
